import { fromEvent, map } from "rxjs";

function radioButton(group){
    const group$ = fromEvent(group, 'change').pipe(
        map((event) => event.target.value)
    );
    
    return group$;
}

export default radioButton;